import { Component, OnInit } from '@angular/core';


import "survey-core/survey.i18n.js";
import "survey-creator-core/survey-creator-core.i18n.js";

import { surveyLocalization } from 'survey-core';

import { ComponentCollection } from "survey-core";
import { Serializer } from "survey-core";
import {  MenuItem, MessageService, SelectItem } from 'primeng/api';
import { SurveyCreatorModel, localization } from "survey-creator-core";
import { setLicenseKey } from "survey-core";

import { ApiService } from 'src/app/_services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-survey-model-edit',
  templateUrl: './survey-model-edit.component.html',
  styleUrls: ['./survey-model-edit.component.css'],
  providers: [ MessageService]
})
export class SurveyModelEditComponent implements OnInit {
  surveyCreatorModel: SurveyCreatorModel;
  isLoading=true;
  creator:any;
  surveymodel={
    name:'',
    id_startup:0
  };
  duplicatename='';
  startupModelsList:SelectItem[] = [];
  surveytitle='';
  archived:boolean=false;
  action='';  
  id:number;
  json_mandatory:any;
  arrmandquestions:any=[];
  breadcrumbs: MenuItem[];
  showDialogDuplicate:boolean=false;
  errors: {
    DescrizioneError: boolean,

  };
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    setLicenseKey("Y2UyZmM4MzktN2Y3ZS00MGY3LWEwOGYtMzM1YjE3MTkwMzkwOzE9MjAyNC0wOC0wNw==" );
   }


  ngOnInit(): void {
    this.populateBreadcrumb();
    this.initErrors();  
    this.loadsurvey('');
    const params: any = {PageSize : 10000};
 
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=null;
    if (!this.route.snapshot.paramMap.get('id')) {
        let params={'archived':false};
        this.apiService.get('surveys-startup-models/listall',params).subscribe(data => {
          const tipiTemp = data.Result;
          for (const tipo of tipiTemp) {
            this.startupModelsList.push({value: tipo.id, label: tipo.name})
          }
        });
    } else {
      this.id=parseInt(this.route.snapshot.paramMap.get('id'));
      let params={'id':this.id};
      this.apiService.get('surveys-models/listall',params).subscribe(data => {
        for (const g of data.Result) {
          if(g['id']==this.id){
            this.surveymodel=g;
            this.archived=false;
            if((this.surveymodel['archived'])&&(this.surveymodel['archived']==1)){
              this.archived=true;
            }
            this.apiService.get('surveys/getmodel',{id:this.id}).subscribe(datamodel => {
            
              this.json_mandatory=JSON.parse(datamodel.Result[0].json_mandatory);
              console.log('json_mandatory',this.json_mandatory);
              this.arrmandquestions=[];
              if((this.json_mandatory)&&(this.json_mandatory.pages)){
                this.json_mandatory.pages.forEach((p,indp)=>{
                  if(p.elements){
                    p.elements.forEach((e,inde)=>{
                      this.arrmandquestions.push(e.name);
                    });
                  }
                });
              }
              
              if(this.surveymodel['json']){
                 this.loadsurvey(this.surveymodel['json']);
              
              }
              this.isLoading=false;
            });
           
          }
        }
      });
  
    }
    
   
 
  }
 
  loadsurvey(jsonsurvey){

    Serializer.addProperty("question", {
      name: "question_weight",
      type: "number",
      displayName: "Question weight",
      category: "general",
      isRequired: true,
      visibleIndex: 0,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_weight", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });

    Serializer.addProperty("question", {
      name: "main_question",
      type: "boolean",
      displayName: "Main question",
      category: "general",
      isRequired: false,
      readOnly: false, // Sbloccato globalmente
      visibleIndex: 1,
      onSetValue: (question: any, value: boolean) => {
          if (value && question && question.survey) {
            question.survey.getAllQuestions().forEach((q: any) => {
                if (q.name !== question.name) {
                    q.setPropertyValue("main_question", false);
                }
            }); 
          }
          question.setPropertyValue("main_question", value);
      }
    });

    Serializer.addProperty("question", {
      name: "nps_question",
      type: "boolean",
      displayName: "Nps question",
      category: "general",
      isRequired: false,
      readOnly: false, // Sbloccato globalmente
      visibleIndex: 2,
      onSetValue: (question: any, value: boolean) => {
          if (value && question && question.survey) {
            question.survey.getAllQuestions().forEach((q: any) => {
                if (q.name !== question.name) {
                    q.setPropertyValue("nps_question", false);
                }
            }); 
          }
          question.setPropertyValue("nps_question", value);
      }
    });

    /*
    // Flag Engagement Question
    Serializer.addProperty("question", {
      name: "engagement_question",
      type: "boolean",
      displayName: "Engagement question",
      category: "general",
      isRequired: false,
      readOnly: false,
      visibleIndex: 3, // Viene mostrato subito sotto
      onSetValue: (survey: any, value: boolean) => {
        survey.setPropertyValue("engagement_question", value);
      }
    });
    */

    Serializer.addProperty("question", {
      name: "section",
      type: "string",
      displayName: "Section",
      category: "general",
      isRequired: false,
      visibleIndex: 4,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("section", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });

    Serializer.addProperty("question", {
      name: "question_chartlabels",
      type: "text",
      displayName: "Chart labels",
      category: "general",
      isRequired: false,
      visibleIndex: 5,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_chartlabels", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });

    Serializer.addProperty("question", {
      name: "question_relatedquestion",
      type: "dropdown",
      displayName: "Related question",
      category: "general",
      isRequired: false,
      visibleIndex: 6,
      choices:  ((obj) =>{
        if(this.creator){
          let ar=[];
          ar.push('');
          this.creator.getAllQuestions().forEach(q => {
             ar.push(q.name);
            
          }); 
          return ar;
        } else {
          return [];
        }
      }),
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_relatedquestion", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });
    Serializer.addProperty("question", {
      name: "mandatory_title",
      type: "string",
      displayName: "Mandatory title",
      category: "general",
      isRequired: false,
      readOnly:true,
      visibleIndex: 7,
    });
 

/*
    Serializer.addProperty("question", {
      name: "question_aggregation",
      title: "Chart labels",
      category: "general",
      choices: [ 
        "1. Accoglienza e info ricevute",
        "2. Ambientazione",
        "3. Igiene e pulizia ambiente",
        "4. Servizio di Ristorazione",
        "5. Servizio di Lavanderia",
        "6. Organizzazione e orari residenza",
        "7. Personale Assistenza",
        "8. Coinvolgimento nel PAI",
        "9. Animazione",
        "10. Fisioterapia",
        "11. Rispetto Privacy",
        "12. Atmosfera e Clima emotivo",
             ],
      visibleIndex: 0,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("question_aggregation", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });
  */
   // localization.currentLocale = "it";
    surveyLocalization.supportedLocales = ["it","en", "de", "es", "fr"];
    if (!Serializer.findClass("rsalist")) {
      ComponentCollection.Instance.add({
        //Unique component name. It becomes a new question type. Please note, it should be written in lowercase.
        name: "rsalist",
        //The text that shows on toolbox
        title: "Residencies",
        //The actual question that will do the job
        questionJSON: {
            type: "dropdown",
            placeholder: "Select a residency..."
        }
      });
    }

    if (!Serializer.findClass("npssmilyes")) {
      ComponentCollection.Instance.add({
        //Unique component name. It becomes a new question type. Please note, it should be written in lowercase.
        name: "npssmilyes",
        //The text that shows on toolbox
        title: "Smilyes for NPS question",
        //The actual question that will do the job
        questionJSON: {
            type: "imagepicker",
            choices:[
              {value:0,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-01.png'},
              {value:1,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-02.png'},
              {value:2,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-03.png'},
              {value:3,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-04.png'},
              {value:4,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-05.png'},
              {value:5,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-06.png'},
              {value:6,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-07.png'},
              {value:7,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-08.png'},
              {value:8,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-09.png'},
              {value:9,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-10.png'},
              {value:10,imageLink:'https://arkiweb2.homeip.net/surveysimages/Facce-11.png'}
            ],
            maxImageHeight: 50,
            maxImageWidth: 50,
            minImageHeight: 50,
            minImageWidth: 50,
            showLabel:true
        }
      });
    }


    const creatorOptions = {
      showLogicTab: false,
      showPreviewTab: false,
      showJSONEditorTab:false,
      questionTypes: ["rsalist","npssmilyes","imagepicker","text", "checkbox", "radiogroup", "dropdown","country","matrix","boolean","rating","comment"]

    };
    this.creator = new SurveyCreatorModel(creatorOptions);
   
    this.creator.onGetPropertyReadOnly.add((sender, options) => {
      var propName = options.property.name;
      
      
      // LUCCHETTO DINAMICO: Blocca i KPI in modo che non siano modificabili dai direttori
      if (propName === 'main_question' || propName === 'nps_question' /* || propName === 'engagement_question' */) {
          options.readOnly = true; 
      }

      // Codice originale per la gestione dei nomi delle domande ereditate
      if(propName == 'name'){
        if(this.arrmandquestions.includes(options.obj.getPropertyValue('name'))){
          options.property.readOnly = true;
          options.readOnly = true;
        }
        options.canShow = true;
      } else {
        options.canShow = true;
      }
    });
    
    this.creator.onElementAllowOperations.add((sender, options) => {
      if(this.arrmandquestions.includes(options.obj.name)) {
          options.allowDelete = false;
          }
     });
    if(jsonsurvey!=''){
      this.creator.text=jsonsurvey;

    }

    

    this.creator.getAllQuestions().forEach(q => {
      if(this.arrmandquestions.includes(q.name)) {
       
        this.json_mandatory.pages.forEach((p,indp)=>{
          if(p.elements){
            p.elements.forEach((e,inde)=>{
              if(q.name==e.name){
                q.mandatory_title=e.title;

                if(e.nps_question)
                  q.nps_question=true;
                else
                  q.nps_question=false;

                if(e.main_question){
                  q.main_question=true;
               
                } else{
                  q.main_question=false;
                }
              
                
              }
            });
          }
        });
      }
     
      
    }); 
   
    this.surveyCreatorModel =this.creator;
  }
  
  private initErrors() {
    this.errors = {} as any;
  
  }
 
  private validate() : boolean {
    let isValid : boolean = true;
    if(this.action=='new'){
      return true
    } else {
      if (!this.creator.JSON.title) {
        this.addSingle('error', 'Error', 'Title field is required');
         isValid = false;
        
      }
      let arrq=[];
    
      if(this.creator.JSON.pages){
    
        this.creator.JSON.pages.forEach((p,indp)=>{
          if(p.elements){
            p.elements.forEach((e,inde)=>{
         
              if(arrq.includes(e.name)){
                this.addSingle('error', 'Error', 'Nome domanda duplicato. Impossibile salvare');
                isValid = false;
              }
              arrq.push(e.name);
  
             });
          }
        });
        console.log(arrq);
      }
    }
   
    return isValid;
  }

  public save() {
    if(this.action=='new'){
      if (this.surveymodel['name']=='') {
        this.addSingle('error', 'Error', 'Title field is required');
        return;
      }
      this.surveymodel['lang']='en';
      if(this.surveymodel.id_startup){

        this.apiService.get('surveys-startup-models/listall',{}).subscribe(data => {
          for (const g of data.Result) {
            if(g['id']==this.surveymodel.id_startup){
              this.surveymodel['lang']=g.lang;
            }
          }
        });
      }

      this.surveymodel['rev']=1;
     
      

      this.apiService.updateSurveyModel(this.surveymodel).subscribe(data => {
        this.addSingle('success', 'Successo', 'Survey model saved');
        this.router.navigateByUrl('/dashboard/surveys/survey-models');
      });

    } else {
      this.initErrors();
      if(!this.archived){
        if (!this.validate()) return;
      }
  
      
   
      this.surveymodel['archived']=false;
      if(this.archived){
        this.surveymodel['archived']=true;
      }
      if(!this.archived){ 
        this.arrmandquestions.forEach((m)=>{
          let found=false;
          if(this.creator.JSON.pages){
            this.creator.JSON.pages.forEach((p,indp)=>{
              if(p.elements){
                p.elements.forEach((e,inde)=>{

                  if(e.name==m){
                    found=true;
                  }
                });
              }
            });
          }
          if(!found){
            this.addSingle('error', 'Error', 'Impossible to save, mandatory question is missing');
            return;
          }
        });
        let isWrong=false;
        let mainquestioncounter=0;
        if(this.creator.JSON.pages){
          
          this.creator.JSON.pages.forEach((p,indp)=>{
            if(p.elements){

              p.elements.forEach((e,inde)=>{
                if(e.question_chartlabels){
                  let arcl=e.question_chartlabels.split('\n');
                  arcl.forEach((li)=>{
                    let arli=li.split(';');
                    if(arli.length!=2){
                      this.addSingle('error', 'Error', 'Impossible to save, chart labels wrong format question:'+e.title);
                      isWrong=true;
                    }
                    if( isWrong){
                      return;
                    }
                    let arlini=arli[0].split('-');
                    if(arlini.length!=2){
                      this.addSingle('error', 'Error', 'Impossible to save, chart labels wrong format question:'+e.title);
                      isWrong=true;
                    }
                    if( isWrong){
                      return;
                    }
                    if((!this.isNumber(arlini[0]))||(!this.isNumber(arlini[1]))){
                      this.addSingle('error', 'Error', 'Impossible to save, chart labels wrong format question:'+e.title);
                      isWrong=true;
                    }
                    if( isWrong){
                      return;
                    }
                  });
                  
                }
                if(e.main_question === true){
                  mainquestioncounter++;
                }
              
              });
            }
          });
        }
        if((mainquestioncounter==0)||(mainquestioncounter>1)){
          this.addSingle('error', 'Error', 'Impossible to save, you have to set one and only one Main Question');
          isWrong=true;
        }
        if( isWrong){
          return;
        }
      }
      
      if(this.id){
        
        this.surveymodel['id']=this.id;
        if(this.action=='newrev'){
          this.surveymodel['rev']=0; 
        }
      } else {
        this.surveymodel['rev']=1;
      }
      if(this.creator.JSON.title[this.creator.JSON.locale]){
        this.surveymodel['name']=this.creator.JSON.title[this.creator.JSON.locale];
      } else {
        this.surveymodel['name']=this.creator.JSON.title;
      }
      if(!this.creator.JSON.locale){
        this.surveymodel['lang']='en';
      } else {
        this.surveymodel['lang']=this.creator.JSON.locale;
      }
      if((this.action=='duplica')&&(this.duplicatename=='')){
        return;
      }
      if(this.action=='duplica'){
        delete this.surveymodel['id'];
        this.surveymodel['name']=this.duplicatename;
      }
    
      this.surveymodel['json']=JSON.stringify( this.creator.JSON );
      let j=0;
      if(this.creator.JSON.pages){
        this.creator.JSON.pages.forEach((p,indp)=>{
          if(p.elements){
            p.elements.forEach((e,inde)=>{
              j++;
            });
          }
        });
      }
      this.surveymodel['questions_count']=j;
      this.apiService.updateSurveyModel(this.surveymodel).subscribe(data => {
        this.addSingle('success', 'Successo', 'Survey model saved');
        if(this.action=='duplica'){
          this.router.navigateByUrl('/dashboard/surveys/survey-models');
        }
      });
    }

  }

  isNumber(value?: string | number): boolean
  {
  
    return ((value != null) &&
            (value !== '') &&
            !isNaN(Number(value.toString())));
  }

  saveduplica(){
    this.action='duplica';
    this.save()
  }
  duplicate(){
    this.showDialogDuplicate=true;
  }
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  private populateBreadcrumb() {
    this.translate.get('breadcrumb').subscribe(labels => {
      this.breadcrumbs = [
        { icon: 'fas fa-home', routerLink: '/dashboard' },
        { label: 'Models', routerLink: '/dashboard/surveys/survey-models'},
        { label: 'Models'},
      ];
    });
  }


}
